module.exports = __webpack_public_path__ + "img/WM.b77e5fc6.png";